import type SocialActivityNotificationPayload from 'owa-service/lib/contract/SocialActivityNotificationPayload';
import loadActivityFeed from '../utils/loadActivityFeed';
import { subscribeToSocialActivityNotification } from 'owa-app-notifications-core';
import { getOpxHostApi } from 'owa-opx';
import { getUnseenItemsCount } from '../store/unseenItemsSelector';
import UserSocialActivityActionType from 'owa-service/lib/contract/UserSocialActivityActionType';
import { logUsage } from 'owa-analytics';

export const updateBadgeHandler = (unseenItemsCount: number) => {
    getOpxHostApi().onActivityFeedAction({
        actionType: 'UpdateBadge',
        unseenItemsCount,
    });
};

let readyToFetchActivityFeed = true;

function onNotificationCallback(notification: SocialActivityNotificationPayload): void {
    switch (notification.Action) {
        case UserSocialActivityActionType.Like:
        case UserSocialActivityActionType.MeMention:
        case UserSocialActivityActionType.FileMention:
        case UserSocialActivityActionType.Reaction:
        case UserSocialActivityActionType.ActivityFeedNotification:
            if (readyToFetchActivityFeed) {
                readyToFetchActivityFeed = false;
                loadActivityFeed().then(() => {
                    updateBadgeHandler(getUnseenItemsCount());
                    readyToFetchActivityFeed = true;
                });
                logUsage('ActivityFeedOpxUpdateFromNotification');
            }
    }
}

export default function subscribeToNotificationOpx(isOpx: boolean = false): void {
    // if isopx we should subscribe to notification to update the activity feed api.
    if (isOpx) {
        subscribeToSocialActivityNotification(isOpx, onNotificationCallback);
    }
}
